import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		classes: PropTypes.string
	};

    render() {

		return (

			<p className={"lead text-center spinner mbot0 " + this.props.classes}><i className="fa fa-spinner"></i></p>
			
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Loaders/PostLoader.js